export var SubscriptionQueryType = /*#__PURE__*/function (SubscriptionQueryType) {
  SubscriptionQueryType["WITH_STATUS"] = "WITH_STATUS";
  SubscriptionQueryType["WITH_DATES"] = "WITH_DATES";
  SubscriptionQueryType["WITH_MOP"] = "WITH_MOP";
  return SubscriptionQueryType;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/SubscriptionUtil/interface/SubscriptionUtilType.js
// module id = 1443
// module chunks = 11